import { render, staticRenderFns } from "./ot-navigation-wrapper.vue?vue&type=template&id=4f56df91&scoped=true&"
import script from "./ot-navigation-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-navigation-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-navigation-wrapper.vue?vue&type=style&index=0&id=4f56df91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f56df91",
  null
  
)

export default component.exports